import React from 'react';
import Layout from '../../src/components/Layout/Layout';
import { CAREER_PAGE } from '../../lib/queries';
import client from '../../lib/apolloClient';
import CareerComponent from '../../src/components/Career/Career';
import CareerVideoComponent from '../../src/components/Career/CareerVideo';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const Career = (props) => {
  const { data } = props;

  return (
    <Layout hero={<CareerVideoComponent data={data.career} />} whiteTextColor>
      <CareerComponent data={data.career} />
    </Layout>
  );
};

export default Career;

export async function getServerSideProps() {
  let { data } = await client.query({ query: CAREER_PAGE });
  data = await replacePictureUrlWithSignedUrl(data);
  return {
    props: { data },
  };
}
